/**
 * 上传文件到腾讯云 COS
 * 参考 kuguanjia-help/src/common/utils/upload.js
 *
 * 用法：
 *   import { fileUpload } from '@/js/common/cosUpload';
 *   const res = await fileUpload(rawFile, { name: rawFile.name }, 'home', onProgress);
 *   // res.url => https://<bucket>.cos.<region>.myqcloud.com/home/xxx.png
 */
import { Message } from 'element-ui';
import { getOssInfo } from './mopRequest';

import cos from './cos';

let Bucket;
let Region;

// 生成唯一文件名：时间戳 + 6 位随机数 + 原扩展名
function randomNum(min, max) {
  return min + Math.floor(Math.random() * (max - min));
}

function getFileName(name) {
  const ext = String(name).split('.').pop();
  return `${new Date().getTime()}${randomNum(100000, 999999)}.${ext}`;
}

/**
 * @param {File|Blob} file 原始文件
 * @param {Object} obj 至少包含 { name }，用于生成 key；上传后会写入 name/url/percent
 * @param {String} path 目录前缀，默认 home
 * @param {Function} [onProgress] 进度回调，参数为 0-100 的百分比
 * @returns {Promise<Object>} resolve 后的 obj（含 name=key、url、percent）
 */
export async function fileUpload(file, obj, path = 'home', onProgress) {
  if (!Bucket) {
    const { data } = await getOssInfo();
    Bucket = data.bucketName;
    Region = data.regionName;
  }
  return new Promise((resolve, reject) => {
    try {
      const fileName = getFileName(obj.name);
      const key = `${path ? `${path}/` : ''}${fileName}`;
      cos.uploadFile(
        {
          Bucket,
          Region,
          Key: key,
          Body: file,
          SliceSize: 1024 * 1024 * 1, // 超过 1MB 自动分片
          onProgress(progressData) {
            const percent = Math.floor(progressData.percent * 100);
            obj.percent = percent;
            if (typeof onProgress === 'function') {
              onProgress(percent);
            }
          },
        },
        (err, data) => {
          if (err) {
            Message.error('上传失败');
            reject(err);
          } else {
            obj.name = key;
            obj.url = `https://${data.Location}`;
            resolve(obj);
          }
        },
      );
    } catch (error) {
      reject(error);
    }
  });
}

export default fileUpload;
